/** Shopify CDN: Minification failed

Line 1096:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 1097:4 Transforming let to the configured target environment ("es5") is not supported yet

**/
/*
 * visiblity detection - https://css-tricks.com/slide-in-as-you-scroll-down-boxes/
*/
!function(i) {
    i.fn.visible = function(t, n) {
        var o = i(this)
          , e = i(window)
          , f = e.scrollTop()
          , h = f + e.height() - n
          , r = o.offset().top
          , s = r + o.height()
          , u = t === !0 ? s : r
          , c = t === !0 ? r : s;
        return h >= c && u >= f
    }
}(jQuery);
(function($){

	window.theme = window.theme || {};
 
	// GLOBAL
	theme.global = {
		
		vars : {
			$animateBlocks: $('.animate-in.hide') 
		},
		
		init : function(){
			var vars = theme.global.vars;
			vars.breakpoint = 768;
			vars.speed = 250;
			vars.$win = $(window);
			vars.$winW = vars.$win.width();	
			vars.$winH = vars.$win.height();
			vars.$body = $('body');
			vars.isMobile = vars.$winW < vars.breakpoint ? true : false;
							 
			vars.$win.on({
				resize: theme.global.resize,
				scroll: theme.global.scroll
			});	

			setTimeout(function(){
				theme.global.scroll();					
			}, 200);
		},
		
		handleize : function (str) {
			return str.toString().toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
		},
  

		resize : function(){
			var vars = theme.global.vars;
			vars.$winW = vars.$win.width();	
			vars.$winH = vars.$win.height();			
			vars.isMobile = vars.$winW < vars.breakpoint ? true : false;
		},
		
		scroll : function(){
			theme.global.animateBlocks();
		},

		animateBlocks: function(){
			
			$('.animate-in.hide').each(function(i, el) {
		    var $el = $(el),
            buffer = 50;
            
        if($el.hasClass('image') && $el.index() == 0){
          $el.removeClass('hide');
        }
		    
		    if ($el.visible(true, buffer)) {
		      $el.removeClass('hide');
		    } 
		  });			
		}			
				
	}
	
	// INIT
	theme.init = function () {
		var $body = $('body');
		
		// global
    theme.global.init(); 
  } 

	
	// PRODUCT
	theme.home = {
		
		vars : {},
		
		init : function(){
			var vars = theme.home.vars,
					globalVars = theme.global.vars;		
					vars.$stream = $('#stream');
					vars.$fullWidthArticles = 0;
					vars.rowArticles = [];
					vars.r = 1;
					vars.rowPlacement = 1;
					vars.reverseRow = 0;
					vars.layoutPattern = [3,2,2];
					vars.threeColLayout = [3,4,5];
					vars.twoColLayout = [5,7];
										
			theme.home.fetchStream();	
			theme.home.doubleTap();
		},
				
				
		fetchStream : function(){
			var vars = theme.home.vars;
			
			vars.articles = hpStream;
			vars.articleCount = vars.articles.length - 1;
			theme.home.preloadImg(0);
			
		},			  	
			  	
		preloadImg: function(i){
			var vars = theme.home.vars,
					article = vars.articles[i];

			//get product info if product tag
			if(article.product_handle){
				articleProduct = jQuery.grep(productList, function( p ) {
				  return p.handle == article.product_handle;
				});
				article.product = articleProduct[0];
			} else {
				article.product = 0;
				article.deets = 'no-deets'; 
			}

    	if(i < vars.articleCount){
    				
				// if has image - load it
				if(article.image){	
					
					$("<img/>",{
			      load : function(){ 
		    			var ratio = this.width / this.height;
		    			article.ratio = ratio;		        	
							article.full = ratio > 2 ? 1 : 0;
		
				    	if(article.full){ vars.$fullWidthArticles++; }	      	
				    	
							theme.home.preloadImg(i + 1);		      
			      },
			      src  : vars.articles[i].image.src
			    });				
				}	
				
				// if unpublished or no image - remove and continue
				else {
					vars.articles.splice(i,1);
					vars.articleCount--;
					theme.home.preloadImg(i);
				} 	
    	} 
    	
    	// if finished loading all, arrange
    	else {
      	theme.home.arrangeArticles();
      	$('#loader').fadeOut(250);
      	setTimeout(function(){
	      	vars.$stream.addClass('show');
	      	theme.global.scroll();      		
      	}, 300);
    	}
			  		
		},
		
		arrangeArticles : function(){	
			var a = 1,
					vars = theme.home.vars,
					total = vars.articleCount - vars.$fullWidthArticles,
					groups = Math.floor(total / 7) + 1,
					currentGroup = 1;
					
			$.each(vars.articles, function(i, article){
			
				// if full width article
//				if(article.full){
					article.columns = 12;
					theme.home.renderRow([article]);
//				} 
				
			});
					
			
		},
		
		compileRow : function(article, numColsOverride){
			var vars = theme.home.vars,
					numCols = numColsOverride > 1 ? numColsOverride : vars.layoutPattern[vars.r%3],
					flip = 0;
					
					
			// determine if layout is is 2 or 3 cols, and if is reversed
			var rowLayout = numCols == 3 ? vars.threeColLayout : vars.twoColLayout;
			var layout = vars.reverseRow ? Array.prototype.slice.call(rowLayout).reverse() : rowLayout;	
			article.columns = layout[vars.rowPlacement - 1];
			vars.rowArticles.push(article);
			
			
			//if final article in row, render and reset
			if(vars.rowPlacement == numCols){
				var ra = vars.rowArticles;
				
				console.log(ra);
				
				//if portrait and 2cols, ensure taller image is in smaller column
				if(numCols == 2){
					var tallest = ra[0].ratio < ra[1].ratio ? ra[0] : ra[1];				
					if(tallest.columns == 7 && tallest.ratio < 0.75){						

						//flip order, but retain columns
						var temp = ra[0];
						ra[0] = ra[1];
						ra[1] = temp;		
						
						var tempCols = ra[0].columns;
						ra[0].columns = ra[1].columns;
						ra[1].columns = tempCols;		

					}		
				} 
				
				else 
				if(numCols == 3){
					var tallest = ra[0].ratio < ra[2].ratio ? 0 : 2;
					if( ra[tallest].columns != 4 && ra[tallest].ratio < ra[1].ratio && ra[tallest].ratio < 0.75){
						
						//flip order, but retain columns
						var temp = ra[tallest];
						ra[tallest] = ra[1];
						ra[1] = temp;									
						
						var tempCols = ra[tallest].columns;
						ra[tallest].columns = ra[1].columns;
						ra[1].columns = tempCols;									
					}
				}
				
				theme.home.renderRow(vars.rowArticles);
				
				//reset for next row
				vars.rowArticles = [];
				vars.r++;
				vars.reverseRow = vars.reverseRow == 0 ? 1 : 0;
				vars.rowPlacement = 1;
			} 
			
			else {
				vars.rowPlacement++;				
			}			
			
				
		},
		
		renderRow : function(articles){
			var vars = theme.home.vars,
					$row = $('<div class="row"></div>');
			
			$.each(articles, function(i, article){						
				var templateSource = $("#stream-article").html(),
						template = Handlebars.compile(templateSource),
						ctx = {article: article},
						itemHTML = template(ctx);
						$row.append(itemHTML);
			});	
			vars.$stream.append($row);	
		},
		
		doubleTap : function(){
			var vars = theme.home.vars;
					vars.$article = vars.$stream.find('.article');


			vars.$stream.on('mouseenter', '.article', function(){				
					var $me = $(this);
					$me.addClass('hover');
					$me.siblings().removeClass('hover');
			});

			vars.$stream.on('mouseleave', '.article', function(){				
					var $me = $(this);
					$me.removeClass('hover');
			});
			
			vars.$stream.on('click', '.article .link', function(e){				
				var $parent = $(this).closest('.article');
				if(!$parent.hasClass('hover')){
					e.preventDefault();				
					$parent.addClass('hover').siblings().removeClass('hover');	
				}
			});		
		}
	
	} 
  $(theme.init);
 
})(jQuery);



